export const trimString = (value: string): string => {
    if (!value) return '';
    return value.replace(/\t/g, ' ').trim();
};

export const toCamelCase = (s: string): string => s.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
